import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import DatePicker, {DayValue} from "@hassanmojab/react-modern-calendar-datepicker";
import {ToxicDigitsFixToEnglish} from "../../../components/techaran/money";
import {GradeToString} from "../students/list";
import {DateFixToGoLayout, GregorianToPersian, PersianToGregorian} from "../../../components/techaran/date-convert";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AdminsAddEditStaffModal = (props: {
    active: boolean,
    closeHandler: any,
    edit: boolean,
    staffId: string,
    onDone: any,
}) => {
    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [tell, setTell] = useState('');
    const [hasPartner, setHasPartner] = useState(true);
    const [homeTell, setHomeTell] = useState('');
    const [partnerTell, setPartnerTell] = useState('');
    const [partnerName, setPartnerName] = useState('');
    const [partnerJob, setPartnerJob] = useState('');
    const [teachingGrade, setTeachingGrade] = useState('1');
    const [isFemale, setIsFemale] = useState(false);
    const [birthDate, setBirthDate] = useState<DayValue>(null);
    const [certificate, setCertificate] = useState('لیسانس');
    const [major, setMajor] = useState('');
    const [yearsActive, setYearsActive] = useState('1');
    const [national, setNational] = useState('');
    const [fatherName, setFatherName] = useState('');
    const [birthCity, setBirthCity] = useState('');
    const [address, setAddress] = useState('');
    const ids = {
        firstname: useId(),
        lastname: useId(),
        tell: useId(),
        homeTell: useId(),
        partnerTell: useId(),
        partnerName: useId(),
        partnerJob: useId(),
        teachingGrade: useId(),
        certificate: useId(),
        major: useId(),
        yearsActive: useId(),
        national: useId(),
        fatherName: useId(),
        birthCity: useId(),
        address: useId(),
    };
    const [err, setErr] = useState({
        firstname: false,
        lastname: false,
        tell: false,
        partnerTell: false,
        teachingGrade: false,
        isFemale: false,
        birthDate: false,
        certificate: false,
        yearsActive: false,
        national: false,
    });
    const fetchData = () => {
        ShowProgressLoading();
        const id = props.staffId;
        PostJSON(
            Apis.server + '/core/admins/staff/get-for-edit',
            {
                id: id.toString(),
            },
            true,
            (d: {
                result: string,
                reason: string,
                firstname: string,
                lastname: string,
                tell: string,
                hasPartner: number,
                homeTell: string,
                partnerTell: string,
                partnerFullname: string,
                partnerJob: string,
                teachingGrade: number,
                isFemale: number,
                birthDate: string,
                certificate: string,
                yearsActive: number,
                nationalCode: string,
                fatherName: string,
                birthCity: string,
                address: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setFirstname(d.firstname);
                setLastname(d.lastname);
                setTell(d.tell.replaceAll('+98','0'));
                setHasPartner(d.hasPartner === 1);
                setHomeTell(d.homeTell);
                setPartnerName(d.partnerFullname);
                setPartnerJob(d.partnerJob);
                setTeachingGrade(d.teachingGrade === 0 ? '13' : d.teachingGrade.toString());
                setIsFemale(d.isFemale === 1);
                const bd = GregorianToPersian(d.birthDate).split('-');
                setBirthDate({
                    year:parseInt(bd[0]),
                    month:parseInt(bd[1]),
                    day:parseInt(bd[2]),
                });
                setCertificate(d.certificate);
                setYearsActive(d.yearsActive.toString());
                setNational(d.nationalCode);
                setFatherName(d.fatherName);
                setBirthCity(d.birthCity);
                setAddress(d.address);
            },
            () => {},
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        const isEdit = props.edit;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            setErr({
                firstname: false,
                lastname: false,
                tell: false,
                partnerTell: false,
                teachingGrade: false,
                isFemale: false,
                birthDate: false,
                certificate: false,
                yearsActive: false,
                national: false,
            });
            if (isEdit) {
                fetchData();
            } else {
                setFirstname('');
                setLastname('');
                setTell('');
                setHasPartner(true);
                setHomeTell('');
                setPartnerTell('');
                setPartnerName('');
                setPartnerJob('');
                setTeachingGrade('13');
                setIsFemale(false);
                setBirthDate({year: 1380, month: 1, day: 1});
                setCertificate('کارشناسی');
                setMajor('');
                setYearsActive('1');
                setNational('');
                setFatherName('');
                setBirthCity('');
                setAddress('');
            }
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const saveData = () => {
        let data = {
            firstname: firstname.trim(),
            lastname: lastname.trim(),
            tell: tell.trim(),
            hasPartner: hasPartner ? '1' : '0',
            partnerFullName: hasPartner ? partnerName : '',
            partnerTell: hasPartner ? partnerTell : '',
            partnerJob: hasPartner ? partnerJob : '',
            homeTell: homeTell,
            isFemale: isFemale ? '1' : '0',
            fatherName: fatherName.trim(),
            nationalCode: national,
            teachingGrade: teachingGrade,
            birthCity: birthCity.trim(),
            birthDate: PersianToGregorian(DateFixToGoLayout(`${birthDate?.year}-${birthDate?.month}-${birthDate?.day}`)),
            certificate: certificate,
            major: major.trim(),
            yearsActive: yearsActive.toString(),
            address: address.trim(),
            id: props.staffId.toString(),
        };
        let errors = {
            firstname: false,
            lastname: false,
            tell: false,
            partnerTell: false,
            teachingGrade: false,
            isFemale: false,
            birthDate: false,
            certificate: false,
            yearsActive: false,
            national: false,
        };
        const isEdit = props.edit;
        let stop = false;
        if (data.firstname.length < 2) {
            stop = true;
            errors.firstname = true;
        }
        if (data.lastname.length < 2) {
            stop = true;
            errors.lastname = true;
        }
        if (data.tell.length !== 11 || data.tell[0] !== '0') {
            errors.tell = true;
            stop = true;
        }
        if (data.partnerTell !== '' && (data.partnerTell.length !== 11 || data.partnerTell[0] !== '0')) {
            stop = true;
            errors.partnerTell = true;
        }
        setErr(errors);
        if (stop)
            return;
        data.tell = '+98' + data.tell.substring(1);
        if (data.hasPartner)
            data.partnerTell = '+98' + data.partnerTell.substring(1);
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/staff/' + (isEdit ? 'edit' : 'add'),
            data,
            true,
            (d: {
                result: string,
                reason: string,
                id: number,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if (d.reason === 'national')
                        setErr(v => {
                            let x = {...v};
                            x.national = true;
                            return x;
                        });
                    else if (d.reason === 'exists')
                        ShowSnackbar('شماره تلفن تکراری است.', 'باشه', 5000);
                    return;
                }
                ShowSnackbar(
                    isEdit ? 'ویرایش کارمند انجام شد.' : 'کارمند جدید افزوده شد.',
                    'باشه', 5000,
                );
                props.onDone();
                props.closeHandler();
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal web-modal-xxl" + (props.active ? ' active' : '')}>
                <div className="web-modal-header">
                    <div><b>{props.edit ? 'ویرایش کارمند' : 'افزودن کارمند'}</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="container">
                        <div className="add-student">
                            <div className="row">
                                <div className="col-lg-4">
                                    <div>
                                        <label htmlFor={ids.firstname}>نام:</label>
                                        <input type="text"
                                               id={ids.firstname}
                                               className={"form-control" + (err.firstname ? ' is-invalid' : '')}
                                               value={firstname}
                                               onChange={e => {
                                                   const t = e.currentTarget.value;
                                                   setFirstname(t);
                                                   setErr(v => {
                                                       let x = {...v};
                                                       x.firstname = false;
                                                       return x;
                                                   });
                                               }}
                                        />
                                        <div className={"invalid-feedback" + (err.firstname ? ' d-block' : ' d-none')}>
                                            لطفا حداقل ۲ کاراکتر وارد کنید.
                                        </div>
                                        <div style={{height: 20}}/>
                                    </div>
                                    <div>
                                        <label htmlFor={ids.lastname}>نام خانوادگی:</label>
                                        <input type="text"
                                               id={ids.lastname}
                                               className={"form-control" + (err.lastname ? ' is-invalid' : '')}
                                               value={lastname}
                                               onChange={e => {
                                                   const t = e.currentTarget.value;
                                                   setLastname(t);
                                                   setErr(v => {
                                                       let x = {...v};
                                                       x.lastname = false;
                                                       return x;
                                                   });
                                               }}
                                        />
                                        <div className={"invalid-feedback" + (err.lastname ? ' d-block' : ' d-none')}>
                                            لطفا حداقل ۲ کاراکتر وارد کنید.
                                        </div>
                                        <div style={{height: 20}}/>
                                    </div>
                                    <div>
                                        <label htmlFor={ids.tell}>تلفن همراه:</label>
                                        <input type="text"
                                               id={ids.tell}
                                               className={"form-control" + (err.tell ? ' is-invalid' : '')}
                                               value={tell}
                                               onChange={e => {
                                                   const t = e.currentTarget.value;
                                                   setTell(ToxicDigitsFixToEnglish(t));
                                                   setErr(v => {
                                                       let x = {...v};
                                                       x.tell = false;
                                                       return x;
                                                   });
                                               }}
                                        />
                                        <div
                                            className={"invalid-feedback" + (err.tell ? ' d-block' : ' d-none')}>
                                            لطفا تلفن همراه را بصورت ۱۱ رقمی با صفر اول وارد کنید.
                                        </div>
                                        <div style={{height: 20}}/>
                                    </div>
                                    <div>
                                        <label>وضعیت:</label>
                                        <button className={"techaran-radio-box" + (hasPartner ? '' : ' active')}
                                                onClick={() => setHasPartner(false)}>
                                            <div><i/></div>
                                            <span>مجرد</span>
                                        </button>
                                        <button className={"techaran-radio-box" + (hasPartner ? ' active' : '')}
                                                onClick={() => setHasPartner(true)}>
                                            <div><i/></div>
                                            <span>متاهل</span>
                                        </button>
                                        <div style={{height: 5}}/>
                                    </div>
                                    {
                                        hasPartner ?
                                            <>
                                                <div>
                                                    <label htmlFor={ids.partnerName}>نام و نام‌خانوادگی همسر:</label>
                                                    <input type="text"
                                                           id={ids.partnerName}
                                                           className={"form-control"}
                                                           value={partnerName}
                                                           onChange={e => {
                                                               const t = e.currentTarget.value;
                                                               setPartnerName(t);
                                                           }}
                                                    />
                                                    <div style={{height: 20}}/>
                                                </div>
                                                <div>
                                                    <label htmlFor={ids.partnerTell}>تلفن همراه همسر:</label>
                                                    <input type="text"
                                                           id={ids.partnerTell}
                                                           className={"form-control" + (err.partnerTell ? ' is-invalid' : '')}
                                                           value={partnerTell}
                                                           onChange={e => {
                                                               const t = e.currentTarget.value;
                                                               setPartnerTell(ToxicDigitsFixToEnglish(t));
                                                               setErr(v => {
                                                                   let x = {...v};
                                                                   x.partnerTell = false;
                                                                   return x;
                                                               });
                                                           }}
                                                    />
                                                    <div
                                                        className={"invalid-feedback" + (err.partnerTell ? ' d-block' : ' d-none')}>
                                                        لطفا تلفن همراه را بصورت ۱۱ رقمی با صفر اول وارد کنید.
                                                    </div>
                                                    <div style={{height: 20}}/>
                                                </div>
                                                <div>
                                                    <label htmlFor={ids.partnerJob}>شغل همسر:</label>
                                                    <input type="text"
                                                           id={ids.partnerJob}
                                                           className={"form-control"}
                                                           value={partnerJob}
                                                           onChange={e => {
                                                               const t = e.currentTarget.value;
                                                               setPartnerJob(t);
                                                           }}
                                                    />
                                                    <div style={{height: 20}}/>
                                                </div>
                                            </> : null
                                    }
                                </div>
                                <div className="col-lg-4">
                                    <div>
                                        <label htmlFor={ids.homeTell}>تلفن منزل:</label>
                                        <input type="text"
                                               id={ids.homeTell}
                                               className={"form-control"}
                                               value={homeTell}
                                               onChange={e => {
                                                   const t = e.currentTarget.value;
                                                   setHomeTell(ToxicDigitsFixToEnglish(t));
                                               }}
                                        />
                                        <div style={{height: 20}}/>
                                    </div>
                                    <div>
                                        <label>جنسیت:</label>
                                        <button className={"techaran-radio-box" + (isFemale ? '' : ' active')}
                                                onClick={() => setIsFemale(false)}>
                                            <div><i/></div>
                                            <span>مرد</span>
                                        </button>
                                        <button className={"techaran-radio-box" + (isFemale ? ' active' : '')}
                                                onClick={() => setIsFemale(true)}>
                                            <div><i/></div>
                                            <span>زن</span>
                                        </button>
                                        <div style={{height: 5}}/>
                                    </div>
                                    <div>
                                        <label htmlFor={ids.fatherName}>نام پدر:</label>
                                        <input type="text"
                                               id={ids.fatherName}
                                               className={"form-control"}
                                               value={fatherName}
                                               onChange={e => {
                                                   const t = e.currentTarget.value;
                                                   setFatherName(t);
                                               }}
                                        />
                                        <div style={{height: 20}}/>
                                    </div>
                                    <div>
                                        <label htmlFor={ids.national}>کد ملی:</label>
                                        <input type="text"
                                               id={ids.national}
                                               className={"form-control" + (err.national ? ' is-invalid' : '')}
                                               value={national}
                                               onChange={e => {
                                                   const t = e.currentTarget.value;
                                                   setNational(ToxicDigitsFixToEnglish(t));
                                                   setErr(v => {
                                                       let x = {...v};
                                                       x.national = false;
                                                       return x;
                                                   });
                                               }}
                                        />
                                        <div className={"invalid-feedback" + (err.national ? ' d-block' : ' d-none')}>
                                            کد ملی وارد شده صحیح نمی‌باشد.
                                        </div>
                                        <div style={{height: 20}}/>
                                    </div>
                                    <div>
                                        <label htmlFor={ids.teachingGrade}>پایه آموزشی:</label>
                                        <select id={ids.teachingGrade} className="form-control" value={teachingGrade}
                                                onChange={e => {
                                                    const t = e.currentTarget.value;
                                                    setTeachingGrade(t);
                                                }}>
                                            <option value="13">{GradeToString(13)}</option>
                                            <option value="1">{GradeToString(1)}</option>
                                            <option value="2">{GradeToString(2)}</option>
                                            <option value="3">{GradeToString(3)}</option>
                                            <option value="4">{GradeToString(4)}</option>
                                            <option value="5">{GradeToString(5)}</option>
                                            <option value="6">{GradeToString(6)}</option>
                                            <option value="7">{GradeToString(7)}</option>
                                            <option value="8">{GradeToString(8)}</option>
                                            <option value="9">{GradeToString(9)}</option>
                                            <option value="10">{GradeToString(10)}</option>
                                            <option value="11">{GradeToString(11)}</option>
                                            <option value="12">{GradeToString(12)}</option>
                                        </select>
                                        <div style={{height: 20}}/>
                                    </div>
                                    <div>
                                        <label htmlFor={ids.birthCity}>شهر محل تولد:</label>
                                        <input type="text"
                                               id={ids.birthCity}
                                               className={"form-control"}
                                               value={birthCity}
                                               onChange={e => {
                                                   const t = e.currentTarget.value;
                                                   setBirthCity(t);
                                               }}
                                        />
                                        <div style={{height: 20}}/>
                                    </div>
                                    <div>
                                        <label>تاریخ تولد:</label>
                                        <DatePicker
                                            value={birthDate}
                                            locale={'fa'}
                                            onChange={e => setBirthDate(e)}
                                            shouldHighlightWeekends={true}
                                            inputPlaceholder={"انتخاب تاریخ..."}
                                            wrapperClassName={"datepicker-wrapper-1"}
                                            inputClassName={"form-control form-control-datepicker"}
                                        />
                                        <div style={{height: 20}}/>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div>
                                        <label htmlFor={ids.certificate}>مدرک تحصیلی:</label>
                                        <select id={ids.certificate} className="form-control" value={certificate}
                                                onChange={e => {
                                                    const t = e.currentTarget.value;
                                                    setCertificate(t);
                                                }}>
                                            {
                                                "زیردیپلم.دیپلم.کارشناسی.کارشناسی ارشد.دکتری.فوق دکتری".split(".").map((c, i) =>
                                                    <option key={"K28ssDj8E_28S" + i}>{c}</option>
                                                )
                                            }
                                        </select>
                                        <div style={{height: 20}}/>
                                    </div>
                                    <div>
                                        <label htmlFor={ids.major}>رشته تحصیلی:</label>
                                        <input type="text"
                                               id={ids.major}
                                               className={"form-control"}
                                               value={major}
                                               onChange={e => {
                                                   const t = e.currentTarget.value;
                                                   setMajor(t);
                                               }}
                                        />
                                        <div style={{height: 20}}/>
                                    </div>
                                    <div>
                                        <label htmlFor={ids.yearsActive}>تعداد سال فعالیت:</label>
                                        <input type="number"
                                               id={ids.yearsActive}
                                               className={"form-control"}
                                               value={yearsActive}
                                               min={0}
                                               onChange={e => {
                                                   const t = e.currentTarget.value;
                                                   setYearsActive(t);
                                               }}
                                        />
                                        <div style={{height: 20}}/>
                                    </div>
                                    <div>
                                        <label htmlFor={ids.address}>نشانی:</label>
                                        <textarea id={ids.address}
                                                  className={"form-control"}
                                                  value={address}
                                                  onChange={e => {
                                                      const t = e.currentTarget.value;
                                                      setAddress(t);
                                                  }}
                                                  style={{minHeight: 100, maxHeight: 200}}
                                        />
                                        <div style={{height: 20}}/>
                                    </div>
                                    <div className="d-flex justify-content-end" style={{gap: 10}}>
                                        <button className="cancel-button" onClick={props.closeHandler}>
                                            <b>انصراف</b>
                                        </button>
                                        <button className="btn-pay" onClick={saveData}>
                                            <b>ذخیره</b>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};